export default __webpack_public_path__ + "static/media/eagle.c9b54ed9.png";